/**
 * @fileoverview Resource Hits Module for InstantSearch.js.
 * Provides functionality to create a custom hits widget for displaying resource items in InstantSearch.js.
 */
import { highlight } from "instantsearch.js/es/helpers";
import { adjustTitleHeights } from "../../Utils";

/**
 * Renders custom resource hits into the specified container.
 * This function is used as a connector for a custom hits widget in InstantSearch.js.
 * It generates a grid layout displaying resource items, each with an image, title, excerpt, content type, and formatted date.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering hits.
 */
const ResourceHits = (renderOptions) => {
    const { hits, widgetParams } = renderOptions;
    if (Object.keys(hits).length > 0) {
        widgetParams.container.innerHTML = `
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    ${hits.map((hit) => `
                        <a href="${hit.permalink}" class="flex flex-wrap content-between hover:bg-primary-pearl pb-5 group">
                            <div class="w-full flex flex-col">
                                <div class="relative image h-[331px] w-full">
                                    <div class="absolute inset-0 z-0 bg-black overflow-hidden">
                                        <img class="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110" src="${hit.featured_image}" alt="${hit.post_title}">
                                    </div>
                                    <div class="bg-primary-orange text-white absolute z-[1] px-3 py-2 top-4 left-4">
                                        ${hit.content_type}
                                    </div>
                                    <div class="h-full w-full bg-black opacity-30"></div>
                                </div>
                                <div class="flex flex-col gap-6 mt-6 px-5">
                                    <div class="font-medium w-full">
                                        ${hit.formattedDate}
                                    </div>
                                    <div class="flex-grow fixed-title-height-js overflow-hidden text-body-large font-medium leading-8 group-hover:underline">
                                        ${highlight({attribute: 'post_title', hit})}
                                    </div>
                                </div>
                            </div>
                        </a>
                    `).join('')}
            </div>
        `;
        document.getElementById("pagination").style.display = 'block';
    } else {
        widgetParams.container.innerHTML = `
            <div class="mt-4">
                <p>There are no resources that match your search.</p
            </div>
        `;
        document.getElementById("pagination").style.display = 'none';
    }
    adjustTitleHeights();
};

export default ResourceHits;